
  import { Component, Vue } from "vue-property-decorator";

  @Component({})
  export default class Tip1 extends Vue {}
